// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import cx from 'classnames';
import PropTypes from 'prop-types';
import ResultSearchForm from './ResultSearchForm';
import styles from './ResultControls.module.scss';
import { ReferralProfile, Specialty } from '../types'; // eslint-disable-line no-unused-vars

/** @typedef {{
  className?: string,
  showSpecialtySelect?: boolean,
  filterByDistance?: boolean,
  referralProfile: ReferralProfile,
  referrableSpecialties: Specialty[],
  openPatientChooseModal: () => any,
  showSendUnassignedButton?: boolean,
  isFetching: boolean
}} ResultControlsPropsType */

/** @type { StatelessComponent<ResultControlsPropsType> } */
const ResultControls = ({
  className,
  showSpecialtySelect,
  filterByDistance,
  referralProfile,
  referrableSpecialties,
  openPatientChooseModal,
  showSendUnassignedButton,
  isFetching,
}) => (
  <div className={cx(className, styles.result_controls)}>
    {showSendUnassignedButton ? (
      <div className={styles.action_container}>
        <button className="button is-link" onClick={openPatientChooseModal}>
          Send Unassigned
        </button>
      </div>
    ) : null}
    <ResultSearchForm
      referrableSpecialties={referrableSpecialties}
      filterByDistance={filterByDistance}
      showSpecialtySelect={showSpecialtySelect}
      referralProfileId={referralProfile.id}
      isFetching={isFetching}
    />
  </div>
);

/** @type { React.ValidationMap<ResultControlsPropsType> } */
const propTypes = {
  showSpecialtySelect: PropTypes.bool.isRequired,
  filterByDistance: PropTypes.bool.isRequired,
  referralProfile: PropTypes.object.isRequired,
  openPatientChooseModal: PropTypes.func,
  isFetching: PropTypes.bool.isRequired,
  showSendUnassignedButton: PropTypes.bool.isRequired,
};

ResultControls.propTypes = propTypes;

ResultControls.defaultProps = {
  filterByDistance: true,
  showSpecialtySelect: true,
  showSendUnassignedButton: false,
};

export default ResultControls;
